export const CREATE_CONVERSATION_REQUEST =
  'intercom/CREATE_CONVERSATION_REQUEST'
export const CREATE_CONVERSATION_SUCCESS =
  'intercom/CREATE_CONVERSATION_SUCCESS'
export const CREATE_CONVERSATION_FAILURE =
  'intercom/CREATE_CONVERSATION_FAILURE'
